import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { NoResultKind, NoResultSurface, useTrackNoResult } from './useTrackNoResult';
import { wishBoxMessages as messages } from './wishBoxMessages';
import { openWishBox } from './wishBoxStore';
import styles from './NoResultWish.module.scss';

interface NoResultWishProps {
  surface: NoResultSurface;
  kind: NoResultKind;
  /** The text of the search: a new text is a new empty search. */
  query: string;
  /** The command palette closes itself before the box opens. */
  onOpen?: () => void;
}

/** The way to the wish box under an empty search (design wish-box a6). */
const NoResultWishComponent: React.FC<NoResultWishProps> = ({ surface, kind, query, onOpen }) => {
  const intl = useIntl();
  useTrackNoResult(surface, kind, query);
  const open = useCallback(() => {
    onOpen?.();
    openWishBox('noResult');
  }, [onOpen]);
  return (
    <button type="button" className={styles.link} onClick={open}>
      {intl.formatMessage(messages.entry)}
    </button>
  );
};

export const NoResultWish = TypedMemo(NoResultWishComponent);
